import React, { useEffect } from 'react';
import { Box, Flex, Text, Image } from '@chakra-ui/react';
import { useRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';

import Layout from '../../layout/layout';
import {
  registration,
  RegistraionModalTypes,
} from '../../../recoil/atoms/registration';
import { user } from '../../../recoil/atoms/user';
import qrcodeIcon from '../../../static/assets/images/qrcodeIcon.svg';
import qrcodeImage from '../../../static/assets/images/qrcodeImage.svg';
import { FaApple, FaGoogleWallet } from 'react-icons/fa';
import googleWallet from '../../../static/assets/images/enUS_add_to_google_wallet_add-wallet-badge.svg';
import appleWallet from '../../../static/assets/images/US-UK_Add_to_Apple_Wallet_RGB_101421.svg';
import portalys from '../../../static/assets/images/Mark.png';
import axios from '../../../utils/api/axios';
import { useMediaQuery } from '../../../utils/useMediaQuery';

import QRCode from 'qrcode.react';
const WalletPage = (props) => {
  const [_, setRegistrationModal] = useRecoilState(registration);
  const [_U, setUser] = useRecoilState(user);
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 768px)');

  useEffect(() => {
    // If user is not logged in, show login modal
    if (isMobile) {
      if (!_U || !_U?.userData?.userId) {
        setRegistrationModal((prev) => ({
          ...prev,
          openModal: true,
          modalType: RegistraionModalTypes.LOGIN,
          userData: {},
          userRole: '',
        }));
      }
    }
  }, [_U, setRegistrationModal]);

  const renderQRCode = () => {
    // Replace this with your actual QR code rendering logic
    return (
      <QRCode
        value={_U.userData?.walletAddress + '/' + Date.now()}
        size={300}
        imageSettings={{
          src: portalys,
          width: 40, // Adjust the logo width as needed
          height: 40, // Adjust the logo height as needed
          excavate: true,
        }}
      />
    );
  };

  const addToApple = async () => {
    if (_U?.token) {
      try {
        const walletAddress = _U?.userData.walletAddress;
        const response = await axios.get('/wallet/download/' + walletAddress, {
          headers: {
            'x-auth-token': _U?.token,
          },
          responseType: 'arraybuffer',
        });
        console.log('aaa', response);
        const blob = new Blob([response.data], {
          type: 'application/vnd.apple.pkpass',
        });

        // Create a URL object from the blob
        const url = window.URL.createObjectURL(blob);

        // Create an anchor element to trigger the download
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'portalys.pkpass'); // Set the filename here
        document.body.appendChild(link);

        // Initiate the download
        link.click();

        // Clean up
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } catch (error) {
        console.error('Error downloading pass:', error);
      }
    }
  };
  const addToGoogle = async () => {
    if (_U?.token) {
      try {
        const walletAddress = _U?.userData.walletAddress;
        const response = await axios.get(
          '/wallet/getGooglePass/' + walletAddress,
          {
            headers: {
              'x-auth-token': _U?.token,
            },
          }
        );
        const passUrl = response.data.passUrl;

        // Initiate the download by opening the URL in a new tab
        window.open(passUrl, '_blank');
      } catch (error) {
        console.error('Error downloading pass:', error);
      }
    }
  };
  return (
    <Layout {...props}>
      {/* Desktop view - always show download app message */}
      <Box
        display={{ base: 'none', md: 'flex' }}
        width="100%"
        maxWidth="600px"
        margin="0 auto"
        padding="2rem"
        minHeight="calc(100vh - 200px)"
        alignItems="center"
        justifyContent="center"
      >
        <Box
          width={'100%'}
          bg="white"
          borderRadius="lg"
          boxShadow="md"
          padding="2rem"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          textAlign="center"
          display="flex"
        >
          <Text
            fontSize="1.5rem"
            fontWeight="600"
            mb="1.5rem"
            color="#000000"
            className="inter-600"
          >
            Only on mobile
          </Text>
          <Text mb="2rem" color="#000000" className="inter-400">
            Please download our app to access your wallet
          </Text>
          <Box
            as="a"
            href="/get-app"
            bg="black"
            color="white"
            py="0.75rem"
            px="2rem"
            borderRadius="md"
            _hover={{ opacity: 0.8 }}
          >
            Download App
          </Box>
        </Box>
      </Box>

      {/* Mobile view - show wallet content or login prompt */}
      <Box display={{ base: 'block', md: 'none' }}>
        {_U && _U.userData?.userId ? (
          <Box
            width="100%"
            maxWidth="600px"
            margin="0 auto"
            padding="2rem"
            minHeight="calc(100vh - 200px)"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Box
              width={'100%'}
              bg="white"
              borderRadius="lg"
              boxShadow="md"
              padding="2rem"
            >
              <Flex
                direction="column"
                alignItems="center"
                justifyContent="center"
                gap="2.5rem"
              >
                <Box>{renderQRCode()}</Box>

                <Text
                  width={'100%'}
                  textAlign={'center'}
                  fontSize={'0.85rem'}
                  className="inter-600"
                  lineHeight={'140%'}
                  letterSpacing={'-0.01rem'}
                  textTransform={'capitalize'}
                  color={'#000000'}
                >
                  Screenshots don't work! The QR code is autogenerated to avoid
                  fraud.
                </Text>
                <Flex
                  justify="center"
                  direction="row"
                  align="center"
                  gap={'10px'}
                >
                  <Box onClick={addToApple}>
                    <Image
                      src={appleWallet}
                      style={{
                        width: '15.75rem',
                        height: '0rem',
                        minHeight: '48px',
                      }}
                    />
                  </Box>
                  <Box onClick={addToGoogle}>
                    <Image
                      src={googleWallet}
                      style={{
                        width: '15.75rem',
                        height: '0rem',
                        minHeight: '48px',
                      }}
                    />
                  </Box>
                </Flex>
              </Flex>
            </Box>
          </Box>
        ) : (
          <Box
            width="100%"
            maxWidth="600px"
            margin="0 auto"
            padding="2rem"
            minHeight="calc(100vh - 200px)"
            alignItems="center"
            justifyContent="center"
            display="flex"
          >
            <Box
              width={'100%'}
              bg="white"
              borderRadius="lg"
              boxShadow="md"
              padding="2rem"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              display="flex"
            >
              <Text
                fontSize="1.5rem"
                fontWeight="600"
                mb="1.5rem"
                color="#000000"
                className="inter-600"
              >
                Please log in
              </Text>
              <Text mb="2rem" color="#000000" className="inter-400">
                Log in to view your wallet
              </Text>
              <Box
                as="button"
                bg="black"
                color="white"
                py="0.75rem"
                px="2rem"
                borderRadius="md"
                _hover={{ opacity: 0.8 }}
                onClick={() =>
                  setRegistrationModal((prev) => ({
                    ...prev,
                    openModal: true,
                    modalType: RegistraionModalTypes.LOGIN,
                    userData: {},
                    userRole: '',
                  }))
                }
              >
                Log In
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </Layout>
  );
};

export default WalletPage;
